import { useEffect, useState } from "react";
import { Link } from "react-router-dom";

import AppContext from "../../store/App/contexts";

import Typography from "@mui/material/Typography";
import ManpowerLogo from "../../assets/images/logos/MPG_BE_Logo_SS_STK_MC_RGB_REG.png";
import PlaystoreLogo from "../../assets/images/logos/playstore.svg";
import AppstoreLogo from "../../assets/images/logos/appstore.svg";

import { config } from "../../config";
const { MANPOWER_POLICY_URL } = config;

const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [policyUrl, setPolicyUrl] = useState(MANPOWER_POLICY_URL);
  const [policyLabel, setPolicyLabel] = useState(
    "Manpower Global Privacy Policy"
  );
  const [showPassword, setShowPassword] = useState(false);
  const [deviceType, setDeviceType] = useState("unknown");

  const emailHandler = (e) => setEmail(e.target.value);
  const passwordHandler = (e) => setPassword(e.target.value);

  useEffect(() => {
    // Detect device type
    const userAgent = navigator.userAgent.toLowerCase();
    if (/android/.test(userAgent)) {
      setDeviceType("android");
    } else if (/iphone|ipad|ipod/.test(userAgent)) {
      setDeviceType("ios");
    } else {
      setDeviceType("other");
    }

    if (window.location.host.includes("employee")) {
      setPolicyUrl("privacy-policy.pdf");
      setPolicyLabel("Manpower Policy on Staff Privacy");
    }
  }, []);

  const getStoreBadge = () => {
    const badgeStyle = {
      height: "40px",
      width: "auto",
      display: "block",
      margin: "0 auto 20px auto",
    };

    if (deviceType === "android") {
      return (
        <a
          href="https://play.google.com/store/apps/details?id=com.powertrack&pcampaignid=web_share"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img
            alt="Download on the Play Store"
            src={PlaystoreLogo}
            style={badgeStyle}
          />
        </a>
      );
    } else if (deviceType === "ios") {
      return (
        <a
          href="https://apps.apple.com/sg/app/powertrack-mpsg/id6756564809"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img
            alt="Download on the App Store"
            src={AppstoreLogo}
            style={badgeStyle}
          />
        </a>
      );
    } else {
      // Desktop or unknown - show both side by side
      return (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            gap: "16px",
            marginBottom: "20px",
          }}
        >
          <a
            href="https://play.google.com/store/apps/details?id=com.powertrack&pcampaignid=web_share"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              alt="Download on the Play Store"
              src={PlaystoreLogo}
              style={{ height: "40px", width: "auto", display: "block" }}
            />
          </a>
          <a
            href="https://apps.apple.com/sg/app/powertrack-mpsg/id6756564809"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              alt="Download on the App Store"
              src={AppstoreLogo}
              style={{ height: "40px", width: "auto", display: "block" }}
            />
          </a>
        </div>
      );
    }
  };

  return (
    <AppContext.Consumer>
      {({ loginHandler }) => (
        <div className="login-container">
          <div className="container">
            <div className="img-responsive text-center">
              <img
                src={ManpowerLogo}
                alt="manpower-logo"
                style={{
                  width: "200px",
                }}
              />
            </div>

            <div className="login-main-input-container">
              <h5>Associate</h5>

              <form
                onSubmit={(e) => loginHandler("associate", email, password, e)}
              >
                <input
                  type="email"
                  className="form-control mt-4 mb-2"
                  value={email}
                  onChange={(e) => emailHandler(e)}
                  placeholder="Email"
                />
                <div style={{ position: "relative" }}>
                  <input
                    type={showPassword ? "text" : "password"}
                    className="form-control"
                    value={password}
                    onChange={(e) => passwordHandler(e)}
                    placeholder="Password"
                  />

                  <span
                    onClick={() => setShowPassword(!showPassword)}
                    style={{
                      position: "absolute",
                      right: "10px",
                      top: "50%",
                      transform: "translateY(-50%)",
                      cursor: "pointer",
                      color: "#555",
                    }}
                  >
                    {showPassword ? (
                      <i
                        className="far fa-eye-slash"
                        style={{ color: "#888383", fontSize: "14" }}
                      ></i>
                    ) : (
                      <i
                        className="far fa-eye"
                        style={{ color: "#888383", fontSize: "14" }}
                      ></i>
                    )}
                  </span>
                </div>
                <button
                  className="btn btn-brand btn-lg btn-block mt-4"
                  type="submit"
                >
                  Log in
                </button>
              </form>
            </div>
            <div className="w-100 text-center mt-4 mb-5">
              <Link to="/forgot-password">Forgot Password?</Link>
            </div>

            {/* Store badge - shows based on device type */}
            {getStoreBadge()}

            <div className="w-100 text-center pb-5">
              <Typography className="text-left">
                By logging-in to your powerTRACK account, you consent to
                Manpower's collection, use and/or disclosure of your personal
                data for the purposes of managing your employment relationship
                with Manpower, and such permitted purposes as set out in{" "}
                <a href={policyUrl}>{policyLabel}</a> and the Personal Data
                Protection Act 2012. For any questions on Manpower's data
                protection practices or the processing of your personal data,
                please contact{" "}
                <a href="mailto: dpofficer@manpower.com.sg">
                  dpofficer@manpower.com.sg
                </a>
                .
              </Typography>
            </div>
          </div>
        </div>
      )}
    </AppContext.Consumer>
  );
};

export default Login;
